import { useMemo, useState } from "react";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import moment from "moment-timezone";
import { useQuery } from "@tanstack/react-query";
import NavigationRefresh from '@mui/icons-material/Refresh';
import { Box, IconButton, Slider, Typography } from "@mui/material";

import chatConfig from './chartConfig'
import { apiRoutes, fetchJson } from "@/src/services";
import { buildQueryUrl } from "@/src/utils";



interface IDayRecord extends Record<string, any> {
    _id: string;
    total: number,
    female: number;
    male: number;
    sponsor: number;
    profiles: number;
}

interface Props {
    timezone: string,
}

const empty = { total: 0, female: 0, male: 0, sponsor: 0 }
export const RegistrationsChart = ({ timezone }: Props) => {
    const [days, setDays] = useState(30);
    const { data, refetch } = useQuery<IDayRecord[]>({
        queryKey: ['new-by-date', days, timezone], queryFn:
            () => fetchJson(buildQueryUrl(apiRoutes.dashboard.newByDate2, { days, timezone }))
                .then(resp => {
                    return resp.json
                }),

        staleTime: Infinity,
        refetchOnWindowFocus: false,
        select: records => records.map((r => ({ ...empty, ...r, profiles: (r.female + r.male) || 0 })))
    }
    );

    const keys = ["total", "male", "female", "sponsor", "profiles"];

    const colors = keys.map(key => chatConfig[key].color);
 
    return (
        <Box>
            <IconButton onClick={() => refetch()} aria-label="refresh" color="primary"><NavigationRefresh /></IconButton>
            <Typography variant="h6" align="center">Registrations</Typography>
            <ResponsiveContainer width="100%" height={220}>
                <LineChart data={data} margin={{ top: 20, right: 10, left: -20, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="_id"
                        tick={{ fontSize: 12 }}
                        tickFormatter={(value) => (!value || value === "auto") ? value : moment(value).tz(timezone).format('D MMM')}
                    />
                    <YAxis tick={{ fontSize: 12 }} />
                    <Tooltip labelFormatter={(value: any) => moment(value).tz(timezone).format('D MMM')}/>
                    <Legend />
                    {keys.map(key =>
                        <Line key={key} dataKey={key}
                            dot={{ r: 3 }}
                            strokeWidth={2} stroke={chatConfig[key].color} activeDot={{ r: 4 }} />)
                    }
                </LineChart>
            </ResponsiveContainer>
            <Box px={"15%"}>
                <Slider
                    value={days}
                    onChange={(e, newValue) => setDays(newValue as number)}
                    marks={[{ value: 30, label: "30" }, { value: 3 * 30, label: "90" }, { value: 6 * 30, label: "180" }, { value: 365, label: "365" }]}
                    // valueLabelDisplay="on"
                    step={null}
                    min={20} max={380}
                />
            </Box>
        </Box>
    )
}